function initializeKeyVisual() {
  new Swiper("#js-keyVisual", {
    effect: "fade",
    fadeEffect: { crossFade: true },
    loop: true,
    loopAdditionalSlides: 1,
    speed: 2000,
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
      waitForTransition: false
    },
    followFinger: false,
    pagination: {
      el: "#js-keyVisual .swiper-pagination",
      clickable: true
    }
  });
}

window.addEventListener("load", function () {
  initializePress();
  initializeGlobalActivities();
});

const BREAK_POINT_MAX = "(max-width: 767px)";

function initializeConcept() {
  if (window.matchMedia(BREAK_POINT_MAX).matches) {
    new Swiper("#js-conceptSlider", {
      slidesPerView: 1.18,
      spaceBetween: 27,
      navigation: {
        prevEl: "#js-conceptSlider .swiper-button-prev",
        nextEl: "#js-conceptSlider .swiper-button-next"
      }
    });
  }
}

function initializeRanking() {
  new Swiper("#js-rankingSlider", {
    slidesPerView: 1.18,
    spaceBetween: 32,
    breakpoints: {
      768: {
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 36
      }
    },
    navigation: {
      prevEl: "#js-rankingSlider .swiper-button-prev",
      nextEl: "#js-rankingSlider .swiper-button-next"
    }
  });
}

function initializePress() {
  new Swiper("#js-pressSlider", {
    slidesPerView: 3.2,
    slidesPerGroup: 3,
    spaceBetween: 16,
    breakpoints: {
      768: {
        slidesPerView: 5.8,
        slidesPerGroup: 6,
        spaceBetween: 32
      }
    },
    navigation: {
      prevEl: "#js-pressSlider .swiper-button-prev",
      nextEl: "#js-pressSlider .swiper-button-next"
    }
  });
}

function initializeGlobalActivities() {
  new Swiper("#js-global-activitiesSlider", {
    slidesPerView: 2.2,
    spaceBetween: 16,
    breakpoints: {
      768: {
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 32
      }
    },
    navigation: {
      prevEl: "#js-global-activitiesSlider .swiper-button-prev",
      nextEl: "#js-global-activitiesSlider .swiper-button-next"
    }
  });
}
